module.exports = __webpack_public_path__ + "img/loading2.18aaed75.gif";